/**
 * Stop double-submissions.
 *
 * This happens when the user hits the submit button multiple times,
 * resulting in the HTTP action being repeated.
 */
(function (jQuery) {
	"use strict";

	function BlockDoubleSubmit() {
		var fn = {
			init: function() {
                fn.unblockAllSubmitButtons();
				jQuery('[block-double-submit]').on('submit', fn.blockSubmitButtons);
			},

            unblockAllSubmitButtons: function() {
                // Protection against forms becoming locked after using the back/forward cache
                jQuery('[submit-is-blocked]').removeAttr('blocked-submit');
            },

            blockSubmitButtons: function(e) {
                if (jQuery(this).find('.stripe-form').length) {
                    // Let Stripe avoid double-submissions; things work a bit differently there
                    return;
                }

                if (jQuery(this)[0].hasAttribute('submit-is-blocked')) {
                    e.preventDefault();
                }

                jQuery(this).attr('submit-is-blocked', true);
            }
		}

		jQuery(fn.init);
	}

	new BlockDoubleSubmit();
})(jQuery);